const _ = require("lodash")
const Errors = require('../../utils/Errors').default

export const entity = {
    name: "Store",
    facets: ["codeName", "translatedField"],
    fields: [
        {
            type: "Organization",
            link: "MTM",

            ps: {
                object: [
                    {
                        $v: function (organizations) {
                            const organizationAxes = organizations.map(organization => organization.organizationAxis.id);
                            const countedAxes = _.countBy(organizationAxes);
                            if (_.some(countedAxes, value => value > 1)) return new Errors.ValidationError(this.options.context.tc("eachStoreShouldBeLinkedToDistinctOrganizationAxis"));
                        }
                    },
                    {
                        $v: function (organizations) {
                            if (!organizations || !organizations.length) return new Errors.ValidationError(this.options.context.tc("storeShouldBeLinkedToAtLeastOneOrganization"));
                        }
                    }
                ]
            }
        },
        {
            path: "organizationNb",
            lazy: true,
            fieldPath: ["organizations.id"],
            f: function()  {
                return this.organizations.length;
            }
        },
        {
            path: "area",
            fieldPath: ["organizations.id", "organizations.fullName", "organizations.organizationAxis.code"],
            f: function()  {
                return this.organizations.find(organization => _.get(organization, "organizationAxis.code") === "Area");
            }
        },
    ],
    filters: [
        {
            name: "byCurrentUserAuditPreparations",
            isDefault: false,
            async: true,
            query: async function(context, callback) {
                try {
                    const userId = context.user.id
                    const preps = await global.app.S.AuditPreparation.find({
                        group: context.group,
                        query: {},
                        fieldPath: ['id', 'store.id', 'auditors.user.id', 'storeContacts.user.id', 'hierarchicalContacts.user.id']
                    })
                    const auditorStoreIds = []
                    const contactPrepIds = []
                    preps.forEach(p => {
                        const isAuditor = (_.get(p, 'auditors') || []).some(a => _.get(a, 'user.id') === userId)
                        const isSC = (_.get(p, 'storeContacts') || []).some(a => _.get(a, 'user.id') === userId)
                        const isHC = (_.get(p, 'hierarchicalContacts') || []).some(a => _.get(a, 'user.id') === userId)
                        if (isAuditor) auditorStoreIds.push(new global.ObjectID(p.store.id))
                        else if (isSC || isHC) contactPrepIds.push(p)
                    })
                    let contactStoreIds = []
                    if (contactPrepIds.length) {
                        const controls = await global.app.S.AuditPreparationControl.find({
                            group: context.group,
                            query: {
                                auditPreparation: {$in: contactPrepIds.map(p => new global.ObjectID(p.id))},
                                status: 'inFollowUp'
                            },
                            fieldPath: ['auditPreparation.id']
                        })
                        const prepIdsWithFollowUp = new Set(controls.map(c => _.get(c, 'auditPreparation.id')))
                        contactStoreIds = contactPrepIds
                            .filter(p => prepIdsWithFollowUp.has(p.id))
                            .map(p => new global.ObjectID(p.store.id))
                    }
                    const storeIds = [...auditorStoreIds, ...contactStoreIds]
                    if (!storeIds.length) return callback(null, {_id: null})
                    return callback(null, {_id: {$in: storeIds}})
                } catch(e) {
                    return callback(null, {_id: null})
                }
            }
        }
    ]
    // context process example
    // TODO doc this somewhere

    // ps: {
    //     object: [{$$u: function (store, callback) {
    //         if(this.options.$v){
    //             return callback(null, store);
    //         }
    //         callback(null, store);
    //
    //     }}],
    //     context: [{$$u: function(context, callback) {
    //         if (this.options.accessType === "S" && context.restAction && context.restAction.crudType === "U") {
    //             context.internalFieldPath.push(...["organizations.id", "organizations.code", "organizations.name"]);
    //         }
    //         callback(null, context);
    //     }}]
    // }
}

export const module_ = {
    object: "Store",
    tKey: "mTitle_store",
    category: {
        path: "referential",
        icon: 'server'
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    // facets: [{name: "codeName", editableCode: false}],
    viewMap: {
        dt: [
            {path: "code", tooltip: true},
            {path: "name", translateName: true},
            {path: "organizationNb", tKey: "attachment_number"}
        ],
        form: [
            {path: "code", editable: false},
            {path: "name", type: "textarea"},
            {path: "organizations", tKey: 'attachments', display: "completeName", required: false}
        ]
    },

    filters: [
        {
            path: "organizations",
            object: "Organization",
            display: "completeName",
            client: true,
            query: function (context) {
                const organizationId = context.data && context.data.organizations && context.data.organizations.id;
                if (organizationId) return {
                    "organizations": new global.ObjectID(organizationId)
                }
            },
            clearable: false
        }
    ]
}
